import { MAPPINGS_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setAppointmentCartItemsMappingList } from "@/app_redux/reducers/slices/auth/mapping_slice";
import { IAppointmentCartItemsMappingListResponse } from "@/api_framework/api_modals/Mapping";

AxiosCurlirize(axios, () => {});
export const useAppointmentCartItemsMappingListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (searchKeyword: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${MAPPINGS_APIS?.APPOINTMENT_CART_ITEMS_MAPPING_LIST?.baseURL}?keyword=${searchKeyword}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAppointmentCartItemsMappingListResponse>) => {
            if (res.data.status === true) {
              dispatch(setAppointmentCartItemsMappingList({ data: res.data.data }));
            } else {
              dispatch(setAppointmentCartItemsMappingList({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
